function InViewAnimation() {
    this.scrollDirectionUp = false;
    this.scrollPos = 0;

    // Set the scroll direction
    window.addEventListener('scroll', e => {
        this.scrollDirectionUp = this.scrollPos > window.scrollY;
        this.scrollPos = window.scrollY;
    });

    inView.offset(0);

    // Animate elements in when entering the view
    inView('.in-view-up')
        .on('enter', el => el.classList.add('done'))
        .on('exit', el => {
            inView.offset(0);
            if (this.scrollDirectionUp) el.classList.remove('done');
        })
    ;
};